var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block py-2 px-6 font-medium text-red-400 border-l-4 border-red-400 bg-red-100 my-2"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }